// Import all images from resources/images to /dist
export const loadImages = () => {
	const images = import.meta.glob( '@/images/**/*', { eager: true } );
	return images;
};

// Auto-loader for all components (JS files under @components)
export const autoLoadComponents = () => {

	const jsModules = import.meta.glob( '@components/**/*.js', { eager: true } );

	const loadedModules = [];

	Object.entries( jsModules ).forEach( ( [ path, module ] ) => {
		const componentName = path.split( '/' ).pop().replace( '.js', '' );
		const componentPath = path.replace( '@components/', '' );

		loadedModules.push( {
			name: componentName,
			path: componentPath,
			module: module,
		} );

	} );

	return loadedModules;

};